import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Main {
    constructor() {
        this.init();
        this.refreshEvent = new CustomEvent("onRefresh");
    }

    init() {
        this.tabFunc();
        this.zoomImg();
        this.setShare();
    }

    zoomImg() {
        const triggers = [...document.querySelectorAll(".js-zoomimg")];
        const wrapper = document.querySelector(".js-zoomimgwrapper");
        const close = document.querySelector(".js-zoomimg_close");

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                const src = el.getAttribute("data-src");
                const img = document.createElement("img");
                img.src = src;
                wrapper.appendChild(img);
            });
        });

        close.addEventListener("click", (e) => {
            wrapper.innerHTML = "";
        });
    }

    tabFunc() {
        const triggers = [...document.querySelectorAll(".js-tabswitch")];
        const tabs = [...document.querySelectorAll(".js-tab")];

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                triggers.forEach((el) => el.classList.remove("-active"));
                tabs.forEach((el) => el.classList.remove("-active"));
                el.classList.add("-active");

                const tgt = el.getAttribute("data-tab");
                const tab = document.querySelector(`.js-tab[data-tab="${tgt}"]`);
                tab && tab.classList.add("-active");

                if (tgt === "tips") {
                    this.setInitialOpenAcc();
                }

                window.dispatchEvent(this.refreshEvent);
            });
        });
    }

    setShare() {
        const btn = [...document.querySelectorAll(".js-setshare")];
        const text = encodeURIComponent(`${document.title} ${location.href}`);
        const snsURL = {
            twitter: "https://twitter.com/intent/tweet?text=" + text,
            facebook: "https://www.facebook.com/sharer.php?u=",
            line: "http://line.naver.jp/R/msg/text/?" + text,
        };

        btn.forEach((el) => {
            const elm = el.querySelector("a");
            elm.setAttribute("href", snsURL[el.getAttribute("data-sns")]);
        });
    }
}
